import { gql } from '@apollo/client';

export const queryTemplateAndContentByIdForCloning = gql`
  query getTemplateAndContent($id: Long!) {
    templateAndContent(id: $id) {
      ... on TemplateAndContent {
        messageType {
          name
          id
        }
        primaryContent {
          ... on EmailContentDefinition {
            fromEmail
          }
          ... on SMSContentDefinition {
            smsSender {
              name
            }
          }
        }
      }
    }
  }
`;

// hardcoded the variable as we are only checking projects with draftMessaging permissions
// the rbacPermissions id for draftMessaging is 3
export const draftMessagingPermissionsProjectsQuery = gql`
  query accessibleProjects {
    accessibleProjects(rbacPermissions: [3]) {
      id
      name
    }
  }
`;

export const cloneJourneyMutation = gql`
  mutation cloneJourney($command: CloneJourneyCommand!) {
    cloneJourney(command: $command) {
      __typename
      ... on CloneJourneySuccess {
        clone {
          id
          projectId
          workflowType
        }
      }
    }
  }
`;
